import React from "react";

const NotFound = () => {
  return <div>The Page you are looking for doesn't exist</div>;
};

export default NotFound;
